import { render, staticRenderFns } from "./ReviewsWidget.vue?vue&type=template&id=64fbc966&scoped=true"
import script from "./ReviewsWidget.vue?vue&type=script&lang=js"
export * from "./ReviewsWidget.vue?vue&type=script&lang=js"
import style0 from "./ReviewsWidget.vue?vue&type=style&index=0&id=64fbc966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbc966",
  null
  
)

export default component.exports